import {
	Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnChanges, SimpleChange,
	ViewChild
} from '@angular/core';
import {SearchBoxComponent} from "../../../../search.box/search.box.component";

@Component({
	selector: 'cp-sb-search',
	templateUrl: './selection.box.search.html',
	styleUrls: ['./selection.box.search.scss'],
	//directives: [SearchBoxComponent],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SelectionBoxSearchComponent implements OnChanges{
	@Input() focus: boolean;
	@Input() disabled: boolean;
	@Input() placeholderTranslationKey: string;

	@Output() searchItems: EventEmitter<string> = new EventEmitter<string>();

	@ViewChild(SearchBoxComponent,{static:false}) searchBox: SearchBoxComponent;

	public showSearch: boolean = false;

	ngOnChanges(changes: {[p: string]: SimpleChange}) {
		if (changes['focus'] && this.searchBox){
			if (changes['focus'].currentValue){
				this.searchBox.focus();
			}
		}
	}

	public clear() {
		if (this.searchBox) {
			this.searchBox.reset();
			this.showSearch = false;
		}
	}

	public onSearch(str: string) {
		this.searchItems.emit(str);
	}

	public onClickOut() {
		if (!this.searchBox.searchString) {
			this.showSearch = false;
		}
	}
}
